import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ATasteOfOurStory from "./sections/ATasteOfOurStory";
import ServicesCardsResidential from "./sections/ServicesCardsResidential";
import CustomerReviews from "./sections/CustomerReviews";
import StunningTransformations from "./sections/StunningTransformations";
import FinalCallToAction from "./sections/FinalCallToAction";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <ATasteOfOurStory />
      <ServicesCardsResidential />
      <CustomerReviews />
      <StunningTransformations />
      <FinalCallToAction />
      <SiteFooter />
    </div>;
}